import React from 'react';
import { useIntl } from 'react-intl-next';
import Button from '@atlaskit/button';
import InboxIcon from '@atlaskit/icon/glyph/tray';
import { P500 } from '@atlaskit/theme/colors';
import Tooltip from '@atlaskit/tooltip';
import { triggerInboxLinkClicked, useCreateFireAnalyticsFromTrigger as useCreateFireAnalyticsFromTriggerDI } from '../../../../common/utils/analytics';
import messages from '../../../../common/utils/i18n/messages';
import { AnimatedInboxButtonContainer } from './styled';
export var INBOX_URL = 'https://start.atlassian.com/notifications';
export var InboxLink = function InboxLink(_ref) {
  var _ref$useCreateFireAna = _ref.useCreateFireAnalyticsFromTrigger,
    useCreateFireAnalyticsFromTrigger = _ref$useCreateFireAna === void 0 ? useCreateFireAnalyticsFromTriggerDI : _ref$useCreateFireAna,
    _ref$shouldPlayAnnoun = _ref.shouldPlayAnnouncementAnimation,
    shouldPlayAnnouncementAnimation = _ref$shouldPlayAnnoun === void 0 ? false : _ref$shouldPlayAnnoun;
  var intl = useIntl();
  var fireInboxLinkClick = useCreateFireAnalyticsFromTrigger(triggerInboxLinkClicked);
  var handleInboxLinkOpened = function handleInboxLinkOpened() {
    fireInboxLinkClick();
  };
  var inboxLinkColour = shouldPlayAnnouncementAnimation ? "".concat("var(--ds-icon-discovery, ".concat(P500, ")")) : undefined;
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: intl.formatMessage(messages.inboxLinkTooltipMessage)
  }, /*#__PURE__*/React.createElement(AnimatedInboxButtonContainer, {
    shouldPlayAnimation: shouldPlayAnnouncementAnimation
  }, /*#__PURE__*/React.createElement(Button, {
    testId: "inbox-link",
    appearance: "subtle",
    target: "_blank",
    href: INBOX_URL,
    iconBefore: /*#__PURE__*/React.createElement(InboxIcon, {
      primaryColor: inboxLinkColour,
      label: ""
    }),
    "aria-label": intl.formatMessage(messages.inboxLinkAriaLabel),
    onClick: handleInboxLinkOpened
  })));
};